
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenApiKeyRequestStatus } from './GenApiKeyRequestStatus';

export class GenStateAccessRequest {

    id: number;
    denialReason: string;
    reason: string;
    stateAbbreviation: string;
    stateId: number;
    stateName: string;
    status: GenApiKeyRequestStatus;
    userId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genStateAccessRequest: GenStateAccessRequest);
    constructor( id: number );

    constructor( input?: GenStateAccessRequest|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.denialReason = input.denialReason; // string [string]
            this.reason = input.reason; // string [string]
            this.stateAbbreviation = input.stateAbbreviation; // string [string]
            this.stateId = input.stateId; // int [number]
            this.stateName = input.stateName; // string [string]
            this.status = (typeof input.status === 'string') ? GenApiKeyRequestStatus.forName(<string> input.status) : <any> input.status; // GenApiKeyRequestStatus
            this.userId = input.userId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenStateAccessRequest[] {
        if (arr && arr.map) {
          return arr.map(a => new GenStateAccessRequest(a));
        } else {
          return [];
        }
    }
}

